import type { Publication } from '~/interfaces/publication';
import type { Site } from '~/interfaces/site';

type LoaderDataWithSite = {
  site?: Pick<Site, 'publication'> | null;
} | null;

// Publication is serialized once, nested on the root site. Page loaders do not repeat it.
export const publicationFromLoaderData = (data: LoaderDataWithSite | undefined): Publication | undefined =>
  data?.site?.publication;

export const publicationFromMatches = (
  matches: ReadonlyArray<{ id?: string; data?: unknown }> | null | undefined,
): Publication | undefined => {
  const root = matches?.find((match) => match.id === 'root');
  return publicationFromLoaderData(root?.data as LoaderDataWithSite | undefined);
};

export const siteFromMatches = (
  matches: ReadonlyArray<{ id?: string; data?: unknown }> | null | undefined,
): Site | undefined => {
  const root = matches?.find((match) => match.id === 'root');
  return (root?.data as { site?: Site } | undefined)?.site;
};
